@if (params.data; as edgeDevice) {
  <div class="flex gap-2">
    <app-edge-device-network-management [edgeDevice]="edgeDevice"></app-edge-device-network-management>

    <app-pan-button
      panRole
      [roles]="['admin', 'installer', 'branch-owner', 'branch-manager']"
      icon="system_update_alt"
      matTooltip="Update Edge Device"
      [disabled]="actionsDisabled()"
      [state]="actionInProgress() === 'update' ? 'loading' : 'default'"
      [swal]="updateDeviceSwal"
    ></app-pan-button>

    <app-pan-button
      panRole
      [roles]="['admin', 'installer', 'branch-owner', 'branch-manager']"
      icon="restart_alt"
      matTooltip="Reboot Edge Device"
      [disabled]="actionsDisabled()"
      [state]="actionInProgress() === 'reboot' ? 'loading' : 'default'"
      [swal]="rebootDeviceSwal"
    ></app-pan-button>

    <app-pan-button panRole [roles]="['admin']" icon="delete" color="danger" (click)="params.deleteCallback(edgeDevice)"></app-pan-button>
  </div>

  <swal
    #updateDeviceSwal
    title="Update Edge Device?"
    text="Are you sure you want to update edge device {{ edgeDevice.serial_number }}?"
    icon="warning"
    confirmButtonText="Yes, Update"
    [showCancelButton]="true"
    [focusCancel]="true"
    (confirm)="updateDevice(edgeDevice)"
  >
  </swal>

  <swal
    #rebootDeviceSwal
    title="Reboot Edge Device?"
    text="Are you sure you want to reboot edge device {{ edgeDevice.serial_number }}?"
    icon="warning"
    confirmButtonText="Yes, Reboot"
    [showCancelButton]="true"
    [focusCancel]="true"
    (confirm)="rebootDevice(edgeDevice)"
  >
  </swal>
}
